// extracted by mini-css-extract-plugin
export var closeButton = "_h0-1";
export var closeX = "_h0-3";
export var container = "_h0-0";
export var image = "_h0-2";